<div class="wrapper">
  <div class="heading text-type-5">{{ data?.bidItem?.item }}</div>
  <div class="description text-type-10">{{ data?.bidItem?.description }} ({{ data?.heading?.name }})</div>
  <div class="uom text-type-14">UOM: {{ data?.bidItem?.uom }}</div>
  <div class="entries text-type-15 mt-[10px]">
    {{ data?.stations?.length }} entr{{ data?.stations?.length === 1 ? 'y' : 'ies' }}
    @if (displayMatched) {
      <span
      class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}</span>
    }
  </div>
  @if (linkedStationCount) {
    <div class="card-linked-count text-type-14" data-testid="design-context-linked-count">{{ linkedCountText(linkedStationCount) }}</div>
  }
</div>
